import script from "./CardDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CardDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./CardDetailModal.vue?vue&type=style&index=0&id=37cd85ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37cd85ec"]])

export default __exports__